import CssBaseline from '@material-ui/core/CssBaseline';
import React, {Component, Suspense} from 'react';
import Banner from './banner_component.js';
import {Container, Body, SearchArea, Graph, Reviews, BackButton, SVG, EntityContainer} from '../styles/app_styles.js';
import {EntityMenuBtn, DropImg} from '../styles/entity_sel_styles.js';
import GraphContainer from '../container/d3_graph_container.js';
// import RatioSlider from '../components/slider.js';
import ReviewsContainer from '../container/reviews_container.js';
import SummaryPanel from '../container/summary_container.js';
import QueryContainer from '../container/query_container.js';
import BlankGraph from '../components/blank_graph_img.js';
import BlankReviewPanel from '../components/blank_reviews_panel.js';
import EntityBar from '../components/entitybar.js';
import EntityList from '../container/dropdown.js';
import Tour from 'reactour';
import {tour_steps} from '../steps/tour_steps.js';
// import Loader from 'react-loader-spinner';
import LoadingIndicator from '../container/loading_indicator.js';
import {trackPromise} from 'react-promise-tracker';
import AppWrapper from "../container/wrapper.js";
let props = {name: "Extreme Reader", pub_ancor: "https://dl.acm.org/doi/abs/10.1145/3366424.3383535", blog_link: "https://megagon.ai/blog/extremereader-an-interactive-explorer-for-customizable-and-explainable-review-summarization/"}

const DEMO_API = process.env.REACT_APP_API

export default class App extends Component {
  constructor(props){
    super(props)
    this.state = {
      entity_selected: "770934d2-4309-4cf0-9ec6-21b312144de6",
      entity_descriptors: {},
      entities: [],
      graph_summary: {},
      text_summary: {},
      terms: [],
      ratio: 10,
      selection: {},
      back_btn_query:[],
      list_open: false,
      customComps: false
    }
    this.deleteQuery = this.deleteQuery.bind(this);
    // this.updateHoverState = this.updateHoverState.bind(this);
    // this.disableHover = this.disableHover.bind(this);
    this.onRevUpdateClick = this.onRevUpdateClick.bind(this);
    this.fetchNode = this.fetchNode.bind(this);
    this.fetchQuery = this.fetchQuery.bind(this);
    this.fetchGraphLoad = this.fetchGraphLoad.bind(this);
    this.dropDownClicked = this.dropDownClicked.bind(this);
    this.onEntitySelect = this.onEntitySelect.bind(this);
    this.modalExit = this.modalExit.bind(this);
    this.fetchNewEntityDatum = this.fetchNewEntityDatum.bind(this);
    this.setTourOpen = this.setTourOpen.bind(this);
  }

  UNSAFE_componentWillMount(){
    this.fetchEntities()
    var id = "770934d2-4309-4cf0-9ec6-21b312144de6"
    this.fetchGraphLoad(id)
    let tour_seen = localStorage.getItem('tour_seen')
    if(tour_seen === 'true'){
      this.setTourOpen(false)
    }else{
      this.setTourOpen(true)
    }
  }

  setTourOpen(state, token){
    //state = bool
    this.setState(
      {isTourOpen: state}
    )
    if(token){
    localStorage.setItem('tour_seen', 'true')
    }
  }

  async fetchGraphLoad() {
    //default hotel info is hard coded because query does not return descriptors.
      var id=this.state.entity_selected
      await fetch(DEMO_API + '/load/' + '?id=' + id,
        {
          method: 'GET'
        })
        .then(res => res.json())
        .then((data) => {
          this.setState({
            entity_descriptors: {
              name: "Cova Hotel",
              num_attributes: 1114,
              num_review: 3075,
              score: 74
            },
            graph_summary: data.graph_summary,
            terms: data.terms,
            text_summary: data.text_summary,
            selection: {
              type: "node",
              object: data.graph_summary.nodes[0]
            },
            load_more_clicked: false,
            list_open: false
          })
        })
      .catch(console.log)

  }

  fetchNewEntityDatum(entity_selected) {
      let id = entity_selected.descriptors.id
      let entity_descriptors = entity_selected.descriptors

      trackPromise(
      fetch(DEMO_API + '/load/' + '?id=' + id,
        {
          method: 'GET'
        })
        .then(res => res.json())
        .then((data) => {
          this.setState({
            entity_descriptors: entity_descriptors,
            entity_selected: id,
            graph_summary: data.graph_summary,
            terms: data.terms,
            text_summary: data.text_summary,
            selection: {
              type: "node",
              object: data.graph_summary.nodes[0]
            },
            load_more_clicked: false,
            list_open: false,
            visibleBackBtn: false
          })
        })
      .catch(console.log)
    )
  }


  fetchQuery(terms, isEmpty, entity){
    var id = entity ? entity.descriptors.id : this.state.entity_selected
    var entity_descriptors = entity ? entity.descriptors : this.state.entity_descriptors

    var encoded_terms = encodeURIComponent(JSON.stringify(terms))

    trackPromise(
    fetch(`${DEMO_API}/search/?id=`+ id +'&&terms=' + encoded_terms ,
    {
      method: 'GET'
    })
    .then(res => res.json())
    .then((data) => {
      let set_terms;
      let state_terms = this.state.terms
      set_terms = isEmpty ? data.terms :  state_terms

      this.setState({
        entity_selected: id,
        entity_descriptors: entity_descriptors,
        graph_summary: data.graph_summary,
        terms: set_terms,
        text_summary: data.text_summary,
        selection: {
          type: "node",
          object: data.graph_summary.nodes[0]
        },
        load_more_clicked: false,
        visibleBackBtn: isEmpty,
        back_btn_query: []
      })
    })
    .catch()
    )
  }


  async fetchEntities(){
    await fetch(`${DEMO_API}/entities`,
    {
      method: 'GET'
    })
    .then(res => res.json())
    .then((data) => {
      let entities = [];
      for(let key in data){
        entities.push(Object.assign(data[key], {id: key}))
      }
      this.setState({
        entities: entities
      })
    })
    .catch()
  }

  fetchNode(nodeID, color_code){
    var node_encoded = encodeURIComponent(JSON.stringify(nodeID))
    var new_color_code = color_code.replace(/\/\*[\s\S]*?\*\/|\/\/.*/g,'')
    var color_encoded = encodeURIComponent(new_color_code)
    var id="770934d2-4309-4cf0-9ec6-21b312144de6"
    trackPromise(
    fetch(`${DEMO_API}/node/?id=`+ id + '&node_id=' + node_encoded + '&color=' + color_encoded,
    {
      method: 'GET'
    })
    .then(res => res.json())
    .then((data) => {
      let terms_instate = this.state.back_btn_query
      let new_back_queries = [...terms_instate, ...data.terms]
      this.setState({
        graph_summary: data.graph_summary,
        text_summary: data.text_summary,
        selection: {
          type: "node",
          object: data.graph_summary.nodes[0]
        },
        load_more_clicked: false,
        back_btn_query: new_back_queries,
        visibleBackBtn: true
      })
    })
    .catch(console.log)
    )
  }

  onRevUpdateClick(type, object){
    if(this.state.selection.object !== object){
      this.setState({selection: {
        type: type,
        object: object
      }})
    }
  }

  deleteQuery(term, ndx) {
    var oldTerms = this.state.terms;
    oldTerms.splice(ndx, 1);
    if(oldTerms.length === 0){
      this.setState({ terms: [], graph_summary:{}, selection: {}, text_summary: {} })
      return
    }
    this.fetchQuery(oldTerms, false);
  }

  renderGraph(data){
    if(!this.state.graph_summary.nodes) {
      return (<BlankGraph>"No Data To Present"</BlankGraph>)
    } else {
      return (<GraphContainer
                onRevUpdateClick={this.onRevUpdateClick}
                fetchNode={this.fetchNode} data={data}
                entity={this.state.entity_selected}
              />)
    }
  }

  renderReviews(){
    if(this.state.selection === undefined || !this.state.selection.object || this.state.selection.object === undefined ){
      return (
        <BlankReviewPanel />
      )
    } else {
      return(<ReviewsContainer
        summary={this.state.graph_summary}
        selection={this.state.selection}
        load_more_clicked={this.state.load_more_clicked}
        />)
    }
  }

  backArrowClick(){
    setTimeout(function(){}, 1000);
    this.stateRevert()
  }

  stateRevert(){
    let back_btn_queries = this.state.back_btn_query
    let user_terms = this.state.terms

    if(back_btn_queries.length === 2 && user_terms.length > 0){
      this.fetchQuery(user_terms, false)
      return
    }

    if(back_btn_queries.length === 0 && user_terms.length === 0){
      this.setState({ terms: [], graph_summary:{}, selection: {}, text_summary: {} })
      return
    }

    let last_query
    if(back_btn_queries.length <= 2 ){
      last_query = this.state.terms
    }else {
      back_btn_queries.slice(-1)
      last_query = back_btn_queries.pop().term
    }

    let isEmpty = false
    if(back_btn_queries.length === 0){
      isEmpty = true
    }

    if(last_query === undefined || last_query.length === 0 ){
    }
    this.fetchQuery(last_query, isEmpty)
  }

  dropDownClicked(){
    this.setState({list_open: true})
  }

  onEntitySelect(entity_selected){
    let terms = this.state.terms
    if(terms.length !== 0){
      this.fetchQuery(terms, false, entity_selected)
    }  else {
      this.fetchNewEntityDatum(entity_selected)
    }
  }

  modalExit(){
    this.setState({list_open: false})
  }

  render(){
    let accentColor = 'linear-gradient( rgba(24,112,57,0.86), rgba(162,210,81,0.83))'
    const BackArrow = require('../images/icons8-go-back-48.png')
    const DropDownArrow = require('../images/drop-down-48.png')
    const title_stat = "true"
    const tour_state = this.state.isTourOpen

    return (
    <React.Fragment>
    <CssBaseline />
      <Container openTour={() => this.setTourOpen(tour_state)}>
      <AppWrapper props={props} data-tut="banner">
      <EntityList
        entities={this.state.entities}
        entity_selected={this.state.entity_selected}
        visible={ this.state.list_open }
        onEntitySelect={this.onEntitySelect}
        onModalClick={this.modalExit}/>
        <Body >
          <LoadingIndicator />
          <EntityContainer data-tut= "title-bar">
            <EntityBar title={title_stat}
            onEntitySelect={this.onEntitySelect}
            descriptors={this.state.entity_descriptors} current_entity = {this.state.entity_selected} />
            <EntityMenuBtn onClick={this.dropDownClicked} >
              <DropImg src={DropDownArrow} alt="downarrow"/>
            </EntityMenuBtn>
          </EntityContainer>
          <SearchArea>
            <QueryContainer
            data={this.state}
            onQuerySelect={this.deleteQuery} updateHoverState={this.updateHoverState}
            disableHover = {this.disableHover}
            searchQuery={this.fetchQuery}
            />
          </SearchArea>
          <SummaryPanel data-tut="summary" summary={this.state.text_summary}/>
          <Graph data-tut="graph_reviews">
            <SVG>
              {
              this.renderGraph(this.state.graph_summary)
              }
            </SVG>
            <BackButton
            visible={ this.state.visibleBackBtn }
            onClick=
            {  ()=> this.backArrowClick()}  >
              <img src={BackArrow} alt="back arrow"/>
            </BackButton>
            {// <RatioSlider props={this.state.ratio} searchRatio={this.searchRatio} data={this.state}/>
            }
          </Graph>
          <Reviews data-tut="reviews">
            {this.renderReviews()}
          </Reviews>
        </Body>
        </AppWrapper>
      </Container>

      <Suspense fallback={<React.Fragment />} >
          <Tour
            onRequestClose={() => this.setTourOpen(false, "token")}
            steps={tour_steps}
            isOpen={this.state.isTourOpen}
            rounded={6}
            accentColor={accentColor}
          />
      </Suspense>
    </React.Fragment>

    );
  }
}
